/**
 * F16.C: branded sign-out screen. Lives at `/c/${slug}/signed-out`. The
 * user lands here after explicitly signing out of the portal's MSAL
 * instance. The portal identity (branding + tenant lock) persists; the
 * "Sign back in" CTA returns to `/c/${slug}` where the title bar's
 * sign-in button is available again.
 */

import { createFileRoute, Link } from '@tanstack/react-router';
import { useTenantBranding } from '../../../lib/tenant/TenantBrandingContext';
import { TenantLogo } from '../../../components/branding/TenantLogo';
import { testIds } from '../../../lib/testIds';

function PortalSignedOut() {
  const { branding, slug } = useTenantBranding();
  return (
    <section
      data-testid={testIds.portal.signedOut}
      className="max-w-xl mx-auto px-6 py-16 flex flex-col items-center gap-6 text-center text-black"
    >
      <TenantLogo size="landing" />
      <div>
        <h2 className="text-2xl font-semibold tracking-tight">
          Signed out of {branding.displayName}
        </h2>
        <p className="mt-2 text-base text-gray-800">
          Your Microsoft session for this portal has been cleared. You can
          sign back in to resume working with {branding.demoSiteName} and
          any connected SharePoint sites.
        </p>
      </div>
      <Link
        data-testid={testIds.portal.signedOutResume}
        to="/c/$clientSlug"
        params={{ clientSlug: slug }}
        className="inline-block text-sm px-4 py-2 border border-black hover:bg-black hover:text-white transition-colors"
      >
        Return to {branding.displayName}
      </Link>
    </section>
  );
}

export const Route = createFileRoute('/c/$clientSlug/signed-out')({
  component: PortalSignedOut,
});
